import axios from './axios-config.js';

export const exposedApi = async (URL) => {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + URL, {
      headers,
    });
    return res.data;
  } catch (error) {
    console.log('error', error);
    throw error;
  }
};

export const get = async (URL, options = {}) => {
  try {
    const res = await axios.get(URL, options);
    return res.data;
  } catch (e) {
    console.log('error', e);
    throw e;
  }
};

export const post = async (body, URL, isJSONRequest = true) => {
  try {
    const res = await axios.post(URL, body);
    return res.data;
  } catch (error) {
    console.log('error', error);
    throw error;
  }
};

export const put = async (body, URL, isJSONRequest = true) => {
  try {
    const res = await axios.put(URL, body);
    return res.data;
  } catch (e) {
    console.log('e', e);
    throw e;
  }
};

export const patch = async (body, URL, isJSONRequest = true) => {
  try {
    const res = await axios.patch(URL, body);
    return res.data;
  } catch (e) {
    console.log('error', e);
    throw e;
  }
};

export const destroy = async (URL) => {
  try {
    const res = await axios.delete(URL);
    return res.data;
  } catch (e) {
    console.log('error', e);
    throw e;
  }
};

export const getReport = async (URL) => {
  try {
    const res = await axios.get(URL);
    return res.data;
  } catch (e) {
    throw new Error(e.message);
  }
};

//LOGOUT
export const logout = async () => {
  try {
    const res = await axios.get('/users/logout');
    return res.data;
  } catch (e) {
    console.log('error', e);
    throw e;
  }
};
